import axios from "axios";
import router from "@/router";

const api = axios.create({
  //Local
  // baseURL: process.env.VUE_APP_API_BASE_URL || "http://localhost:8000/api",
  // assetsBaseURL: process.env.VUE_APP_ASSETS_BASE_URL || "http://localhost:8000/storage/",

  //dev
  // baseURL: process.env.VUE_APP_API_BASE_URL || "http://localhost:2083/api",
  // assetsBaseURL: process.env.VUE_APP_ASSETS_BASE_URL || "http://localhost:2083/storage/",

  //Prod
  baseURL: process.env.VUE_APP_API_BASE_URL || "https://dressmaker.valihub.com/api",
  assetsBaseURL: process.env.VUE_APP_ASSETS_BASE_URL || "https://dressmaker.valihub.com/storage/",
});

let authToken = localStorage.getItem("user_token");

api.defaults.headers.common["Authorization"] = "Bearer " + authToken;
api.defaults.headers.common["Content-type"] = "application/json";
api.defaults.headers.common["Accept"] = "application/json";

// Add interceptor
api.interceptors.response.use(
  function (response) {
    // Do something with response data
    return response;
  },
  function (error) {
    // Do something with response error
    if (error.response?.status == 401) {
      localStorage.removeItem("user_token");
      if (router.currentRoute.value.name != "login" && router.currentRoute.value.name != "register" && router.currentRoute.value.meta.requiresAuth) {
        router.push({ name: "login" });
      }
    }
    return Promise.reject(error);
  }
);

export default api;
